import React from 'react';
import PropTypes from 'prop-types';
import { CollapseCard, Card } from '@totalsoft/rocket-ui';

const CollapseOrBlankCard = ({ canExpand, title, icon, iconColor, ...rest }) => {
  return (
    <>
      {canExpand ? (
        <CollapseCard title={title} icon={icon} iconColor={iconColor} {...rest} toggleOnHeaderClick />
      ) : (
        <Card title={title} icon={icon} iconColor={iconColor} />
      )}
    </>
  );
};

CollapseOrBlankCard.propTypes = {
  canExpand: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.object,
  iconColor: PropTypes.string
};

export default CollapseOrBlankCard;
